/**
 * Created by vtbelo on 01.04.2021
 */

Merge2UnitsShop.PRODUCTS = {};
Merge2UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_RESOURCE] = {
    refreshTimeout: cleverapps.parseInterval("1 day"),
    refreshPrice: 40,

    slots: [
        // 1
        {
            unit: {
                code: "ff",
                stage: 5,
                amount: 1
            },
            type: Product.TYPE_HARD,
            left: 1
        },
        // 2
        {
            unit: {
                code: "ff",
                stage: 4,
                amount: 1
            },
            type: Product.TYPE_HARD,
            left: 1
        },
        // 3
        {
            unit: {
                code: "dd",
                stage: 0,
                amount: 1
            },
            type: Product.TYPE_FREE,
            videoBonus: true,
            left: 1
        },
        // 4
        {
            unitType: "resource",
            left: 5,
            minStage: 0,
            maxStage: 3
        },
        // 5
        {
            unitType: "resource",
            left: 5,
            minStage: 0,
            maxStage: 3
        },
        // 6
        {
            unitType: "resource",
            left: 5,
            minStage: 0,
            maxStage: "opened"
        },
        // 7
        {
            unitType: "resource",
            left: 5,
            minStage: 0,
            maxStage: "opened"
        },
        // 8
        {
            unitType: "resource",
            left: 5,
            minStage: 5,
            maxStage: "opened"
        },
        // 9
        {
            random: [
                {
                    unitType: "generator",
                    left: 1,
                    minStage: 0,
                    maxStage: 0
                },
                {
                    unitType: "sidequest",
                    left: 1,
                    minStage: 0,
                    maxStage: 5
                }
            ]
        }
    ]
};

Merge2UnitsShop.BOOSTER_PRODUCTS = {};
Merge2UnitsShop.BOOSTER_PRODUCTS[ShopWindow.TABS.UNITS_RESOURCE] = {
    refreshTimeout: cleverapps.parseInterval("1 day"),
    refreshPrice: 40,
    ads: true,

    boosters: {
        lr: [2],
        pc: [2],
        sc: [2],
        am: [5, 3, 2],
        ec: [5, 3, 2],
        hg: [5, 3, 2]
    },

    slots: [
        // 1
        {
            unit: {
                code: "dd",
                stage: 0,
                amount: 1
            },
            type: Product.TYPE_FREE,
            videoBonus: true,
            left: 1
        },
        // 2
        {
            unit: {
                code: "ff",
                stage: 4,
                amount: 1
            },
            type: Product.TYPE_HARD,
            left: 1
        },
        // 3
        {
            unitType: "booster"
        },
        // 4
        {
            unitType: "booster"
        },
        // 5
        {
            unitType: "booster"
        },
        // 6
        {
            unitType: "booster"
        },
        // 7
        {
            unitType: "booster"
        }
    ]
};
